import React from 'react';
import { useHistory, useParams } from "react-router-dom";
import { useState } from 'react';
import { useEffect } from 'react';
import API from "../../../Services/BaseService";
import ManageAccountLinks from "../../../Component/ManageAccountLinks/ManageAccountLinks"
import ls from 'local-storage';
import StateAndCity from '../../../Component/StateAndCity/StateAndCity';
import CommonPopup from '../../../Component/CommonPopup/CommonPopup';
import { useForm } from "react-hook-form";
import Datetime from 'react-datetime';
import moment from 'moment';
import PhoneInput from 'react-phone-number-input/input';
import { useSelector } from 'react-redux';
import appstore from '../../../assets/img/appstore.png';
import googleplay from '../../../assets/img/googleplay.png';
import adduser from '../../../assets/img/adduser.jpg';
import PhoneInputs from 'react-phone-input-2'
import StateAndCitySearch from '../../../Component/StateAndCity/StateAndCitySearch';
import PageNotFound from '../../FallBackUI/PageNotFound';

const AddUser = (props) => {
	const history = useHistory();

	const { register, handleSubmit, formState: { errors } } = useForm();
	const { flagFilter, selectSellerId, sellerReqId } = props.location.state;

	// let userDetails = ls.get('userDetails');
	const [firstName, setFirstName] = useState("");
	const [lastName, setLastName] = useState("");
	const [phoneNumber, setPhoneNumber] = useState("");
	const [address, setAddress] = useState("");
	const [sslNo, setSslno] = useState("");
	const [date, setDate] = useState("");
	const [time, setTime] = useState("");
	const [stateName, setStateName] = useState("");
	const [cityName, setCityName] = useState("");
	const [post_car, setPost_car] = useState(0);
	const [remove_car, setRemove_car] = useState(0);
	const [counter_bid, setCounter_bid] = useState(0);
	const [create_user, setCreate_user] = useState(0);
	const [user, setUser] = useState(0);

	const [buy_now, setBuyNow] = useState(0);
	const [cancel_bid, setCancelBid] = useState(0);
	const [bid, setBid] = useState(0);
	const [proxy_bid, setProxy_bid] = useState(0);
	//const [counter_bid, setCounter_bid] = useState(0);
	const [lot_fee, setLot_fee] = useState(0);
	const [option, setOption] = useState("");
	const [isOpen, setIsOpen] = useState(false);
	const [doc, setDoc] = useState("");
	const [popupTitle, setPopupTitle] = useState("");
	const [popupMsg, setPopupMsg] = useState("");
	const [popupType, setPopupType] = useState("");
	const [popupActionType, setPopupActionType] = useState("");
	const [popupActionValue, setPopupActionValue] = useState("");
	const [popupActionPath, setPopupActionPath] = useState("")
	const [selectPivilege, setSelectPivilege] = useState(false)
	const [deselectPrivilege, setDeselectPrivilege] = useState(true)
	const [firstNameError, setFirstNameError] = useState("");
	const [lastNameError, setLastNameError] = useState("");
	const [phoneNumberError, setPhoneNumberError] = useState("");
	const [emailError, setEmailError] = useState("");
	const [addressError, setAddressError] = useState("");
	// const [sslError, setSslError] = useState("");
	const [stateAndCityError, setStateAndCityError] = useState("");
	const [optionError, setoptionError] = useState("");
	const [type, setType] = useState("");
	// const [state, setState] = useState("1");
	// const [city, setCity] = useState("1");
	// const [zipcode, setZipcode] = useState("1");
	const successData = useSelector(state => state.LoginReducer.payload);
	const dealerData = useSelector(state => state.DealerReducer.payload);
	const [sellerreqId, setSellerreqId] = useState("");
	const [idStatename, setIdStatename] = useState(null);
	const [idCityname, setIdCityname] = useState(null);
	const [idZipcodename, setidZipcodename] = useState(null);
	const [stateCityFlag, setStateCityFlag] = useState("");

	const [phoneNo, setPhoneNo] = useState([{ "id": `phoneNo${0}`, "phone_no": "", "extentation": "", "country_code": "+1" }]);
	const [email, setEmail] = useState([{ "id": `email${0}`, "value": "" }]);
	const [fields, setFields] = useState([{ "id": `email${0}`, "value": "" }]);
	const [phoneFields, setPhoneFields] = useState([{ "id": `phoneNo${0}`, "phone_no": "", "extentation": "", "country_code": "+1" }]);
	const [otherEmail, setOtherEmail] = useState([]);

	const [dealerFlag, setDealerFlag] = useState(false);
	const [primaryPhone, setPrimaryPhone] = useState("");
	const [state, setState] = useState("");
	console.log("primaryPhone", primaryPhone);
	const [city, setCity] = useState("");
	const [zipcode, setZipcode] = useState("");
	const [searchName, setSearchName] = useState("")
	const [searchList, setSearchList] = useState("");
	const [emailId, setEmailId] = useState("");
	const [requestId, setRequestId] = useState("");
	const [privilegesObj, setPrivilegesObj] = useState({})
	const [isPrivileges, setIsPrivileges] = useState(false)
	const [selectedStandingID, setSelectedStandingID] = useState("");
	const [standError, setStandError] = useState("");
	const [sslError, setSslError] = useState("");

	console.log("data checking", searchList);

	const [dealerList, setDealerList] = useState("");
	const [sellerId, setSellerId] = useState("")
	const [statusColor, setStatusColor] = useState("")
	const [status, setStatus] = useState("");
	const [statusStanding, setStatusStanding] = useState("");
	const [stand, setStand] = useState("");
	const [selectedStatus, setSelectedStatus] = useState("");
	var _ = require('lodash');


	const [buyEmailsList1, setBuyEmailsList1] = useState([]);
	const [buyEmailsList2, setBuyEmailsList2] = useState([]);
	const [sslnoList, setSslnoList] = useState([]);

	const [addErrors, setAddErrors] = useState("");
	const [errorFlag, setErrorFlag] = useState(false);
	const [extentation, setExtentation] = useState("");
	const [originalValues1, setOriginalValues1] = useState({});
	const [originalValues2, setOriginalValues2] = useState({});

	const [standingSellerStatusId, setStandingSellerStatusId] = useState("");
	//histroy changes
	const [changesFlag, setChangesFlag] = useState("no");
	const [changesArray, setChangesArray] = useState([]);
	const [country, setCountry] = useState("");
	console.log("changesArray", changesArray);
	console.log("phoneNo", phoneNo);
	console.log("phoneFields", phoneFields);

	const getBuyEmail = () => {

		API.post("selleremaillists/condition").then((response) => {

			if (response.data.success === true) {

				setBuyEmailsList1(response.data.data);
				setBuyEmailsList2(response.data.data1);
			}
			else {
				setAddErrors(response.data.error)
				setErrorFlag(true)
			}

		})
			.catch(function (error) {
				if (error.response) {
					setAddErrors(error.response.data.error)
					setErrorFlag(true)
				}
			});
	}

	const getSslno = () => {

		API.post("sellerSslnoLists/condition").then((response) => {

			if (response.data.success === true) {
				setSslnoList(response.data.data);
			}
			// else {
			//     setAddErrors(response.data.error)
			//     setErrorFlag(true)
			// }

		})
		//     .catch(function (error) {
		//       if (error.response) {
		//           setAddErrors(error.response.data.error)
		//           setErrorFlag(true)
		//       }
		//   });
	}
	const handleInput = (e) => {
		if (e.key === 'Enter') {
			e.preventDefault();
		}
	}
	// onKeyPress={e => {

	//   }}

	const OnSearch = (e) => {
		const newName = e.target.value.replace(/[^a-zA-Z\s,0-9]/g, "");
		setSearchName(newName)


		// handleNameChange(e.target.value)
	}

	const getSearchDetails = () => {
		// console.log("=====data=======>", data)
		let request = {
			seller_search_id: searchName,
			seller_dealer_id: dealerData == undefined || dealerData === null ? successData.seller_dealer_id : dealerData.seller_dealer_id,
			// seller_dealer_id: data,
			seller_token: successData.seller_token,
			seller_id: successData.seller_id,

		}
		console.log("getSearchDetails", request);
		// return
		// if (data !== "") {
		API.post("selleridsearch/condition", request)
			.then((response) => {
				if (response.data.data.length !== 0) {
					// handlestatus();
					setSelectedStatus(response.data.data[0]?.standing)
					setSearchList(response.data.data[0]);
					setSellerId(response.data.data[0].seller_id)
					setStatusColor(response.data.data[0].color)
					console.log("color", response.data.data[0].color);
					console.log("setSearchList testing123", response.data.data[0])
					// setDealerId(response.data.data[0].);
					// setDealerName(response.data.data[0].);
					setFirstName(response.data.data[0].first_name);
					setLastName(response.data.data[0].last_name);
					setSslno(response.data.data[0].ssl_no);
					setAddress(response.data.data[0].address);
					setEmail(response.data.data[0].email)
					console.log("setEmail 234", response.data.data[0].email);
					// setPhoneNo(response.data.data[0].phone_no)
					setOption(response.data.data[0]?.no_years)
					setDealerList(response.data.data1)
					setRequestId(response.data.data[0].seller_request_id)
					setDealerFlag(true)
					formatPhone(response.data.data[0].phonenolist.map(data => data.phone_no))
					setEmailId(response.data.data[0].emaillist);
					setStandingSellerStatusId(response.data.data[0].standing_seller_status_id)
					console.log("setDealerList checking", response.data.data[0]);
					setState(response.data.data1[0].state_name);
					setCity(response.data.data[0].city_name)
					setZipcode(response.data.data[0].zipcode)
					setCreate_user(response.data.data[0].create_user)
					setUser(response.data.data[0].user_list)

					setCounter_bid(response.data.data[0].counter_bid)
					setPost_car(response.data.data[0].post_car)
					setRemove_car(response.data.data[0].remove_car)
					console.log("sellerSearch", response.data.data.length)
					setPrivilegesObj({
						// buyNow : res.data.data[0].buy_now,
						// cancelBid: res.data.data[0].cancel_bid,
						// bid: res.data.data[0].bid,
						// proxyBid: res.data.data[0].proxy_bid,
						// counterBid: res.data.data[0].counter_bid,
						// lotFee: res.data.data[0].lot_fee
						createUser: response.data.data[0].create_user,
						counterBid: response.data.data[0].counter_bid,
						postCar: response.data.data[0].post_car,
						User: response.data.data[0].user_list,
						removeCar: response.data.data[0].remove_car

					})
					setIsPrivileges(successData.seller_id === response.data.data[0].seller_id ? false : true)
					if (response.data.data[0].create_user == 1 || response.data.data[0].counter_bid == 1 || response.data.data[0].post_car == 1 ||
						response.data.data[0].remove_car == 1 || response.data.data[0].user_list == 1) {
						setSelectPivilege(true)
						setDeselectPrivilege(false)
					} else {
						setSelectPivilege(false)
						setDeselectPrivilege(true)
					}


				}

				else if (response.data.data.length == 0 || searchName == "") {
					togglePopup()
					setPopupTitle("Data not found ");
					setPopupType("error");
					setPopupActionType("close");
					setPopupActionValue("ok");
					// setPopupActionPath("/seller")

					setEmail("")
					setFirstName("")
					setLastName("")
					setPhoneNo("")
					setEmail("")
					setSslno("")
					setAddress("")
					setState("")
					setCity("")
					setZipcode("")
					setOption("")

				}

				else {
					setAddErrors(response.data.error)
					setErrorFlag(true)
					console.log("errors123", errors);

				}
			},)
			.catch(function (error) {
				if (error.response) {
					setAddErrors(error.response.data.error)
					setErrorFlag(true)
					// setLoading(false);
				}
			});

		// }
		// } 
		// else {
		//     setUserList(oldUserList);

		// }
	}

	useEffect(() => {
		getBuyEmail();
		getSslno();
		DataStatus();

	}, [])

	//console.log("=====userDetails====>", userDetails)
	//console.log("======>", userDetails.dealer_id)
	const togglePopup = () => {
		setIsOpen(!isOpen);
	}
	const getFiles = (e) => {
		const file = e.target.files[0];

		if (!file) return;

		console.log("================>", file.type);
		console.log("check the incoming file", file.name);

		setType("");

		if (
			file.type.includes("jpg") ||
			file.type.includes("jpeg") ||
			file.type.includes("png")
		) {
			const reader = new FileReader();

			reader.onload = (event) => {
				const base64 = event.target.result.split(",")[1];

				const fileData = {
					name: file.name,
					type: file.type,
					size: file.size,
					base64: base64,
				};

				setDoc(fileData);
			};

			reader.readAsDataURL(file);
		} else {
			setType("0");
			return;
		}

		setChangesFlag("yes");

		const newvalue = file.name;
		const oldvalue = "";

		const existingChangeIndex = changesArray.findIndex(
			(change) => change.name === "Document"
		);

		if (existingChangeIndex !== -1) {
			const updatedChangesArray = [...changesArray];
			updatedChangesArray[existingChangeIndex] = {
				oldvalue,
				newvalue,
				name: "Document",
			};
			setChangesArray(updatedChangesArray);
		} else {
			setChangesArray([
				...changesArray,
				{
					oldvalue,
					newvalue,
					name: "Document",
				},
			]);
		}
	};

	const setUserPrivileges = (data) => {

		setChangesFlag("yes")

		const newValue = data;
		const oldvalue = ""

		const formattedNewValue = newValue == 0 ? 'no' : 'yes';
		const existingChangeIndex = changesArray.findIndex(change => change.name === 'Select Seller Privileges');
		if (existingChangeIndex !== -1) {
			const updatedChangesArray = [...changesArray];
			updatedChangesArray[existingChangeIndex] = { oldvalue: oldvalue, newvalue: formattedNewValue, name: 'Select Seller Privileges' };
			setChangesArray(updatedChangesArray);
		} else {
			const change = { oldvalue: oldvalue, newvalue: formattedNewValue, name: 'Select Seller Privileges' };
			setChangesArray([...changesArray, change]);
		}
		if (data == 0) {
			setPost_car(0);
			setRemove_car(0);
			setCreate_user(0);
			setUser(0)
			//setProxy_bid(0);
			setCounter_bid(0);
			//setLot_fee(0);
			setDeselectPrivilege(true)
			setSelectPivilege(false)
		}
		else {
			setPost_car(1);
			setRemove_car(1);
			setCreate_user(1);
			setUser(1)
			//setProxy_bid(0);
			setCounter_bid(1);
			//setLot_fee(0);
			setDeselectPrivilege(false)
			setSelectPivilege(true)
		}

	}
	const setUserPrivilegesAdd = (data) => {

		setChangesFlag("yes")

		const newValue = data;
		const oldvalue = ""

		const formattedNewValue = newValue == 0 ? 'no' : 'yes';
		const existingChangeIndex = changesArray.findIndex(change => change.name === 'Select Seller Privileges');
		if (existingChangeIndex !== -1) {
			const updatedChangesArray = [...changesArray];
			updatedChangesArray[existingChangeIndex] = { oldvalue: oldvalue, newvalue: formattedNewValue, name: 'Select Seller Privileges' };
			setChangesArray(updatedChangesArray);
		} else {
			const change = { oldvalue: oldvalue, newvalue: formattedNewValue, name: 'Select Seller Privileges' };
			setChangesArray([...changesArray, change]);
		}

		if (data == 0) {
			setPost_car(0);
			setRemove_car(0);
			setCreate_user(0);
			setUser(0)
			//setProxy_bid(0);
			setCounter_bid(0);
			//setLot_fee(0);
			setDeselectPrivilege(true)
			setSelectPivilege(false)
		}
		else {
			setPost_car(1);
			setRemove_car(1);
			setCreate_user(1);
			setUser(1)
			//setProxy_bid(0);
			setCounter_bid(1);
			//setLot_fee(0);
			setDeselectPrivilege(false)
			setSelectPivilege(true)
		}

	}

	const inputProps = {
		placeholder: 'DD/MM/YYYY',
		required: true
	};

	const yesterday = moment().subtract(1, 'day');
	const disablePastDt = current => {
		return current.isAfter(yesterday);
	};
	function formatMobileNO(value) {
		var x = value.replace(/\D/g, '').match(/(\d{1})(\d{3})(\d{3})(\d{4})/);

		console.log("value of x", x);
		value = '+' + x[1] + '(' + x[2] + ')' + x[3] + '-' + x[4];
		console.log("mobileno", value);
		return value;
	}

	const handleAdd = () => {
		const length = fields.length
		console.log("length", length);
		let object1 = {
			"oldvalue": "",
			"newvalue": "",
			"name": "Alternative Email",
			"id": `email${length}`,
			"flag": "Add"
		};

		changesArray.push(object1);
		const values = [...fields, { "value": "" }];
		setFields(values.map((data, index) => { return { "id": `email${index}`, value: data.value } }));
		setEmail(values.map((data, index) => { return { "id": `email${index}`, value: data.value } }));
	}
	const onhandleEmail = (e, indexId) => {
		const { id, value } = e.target;

		if (!email.length) {
			setEmail([{ id, value }]);
			setFields([{ id, value }]);
			setChangesFlag("yes");
			const newChangesArray = [
				{
					oldvalue: "",
					newvalue: value,
					name: "Alternative Email",
					id,
					flag: "Add",
				},
			];
			setChangesArray(newChangesArray);
			setOriginalEmailValues({ [id]: "" });
		} else {
			const updatedOriginalValues = { ...originalEmailValues };
			const findIndex = email.findIndex((myData) => myData.id === id);

			if (findIndex >= 0) {
				let emailData = [...email];

				if (!updatedOriginalValues.hasOwnProperty(id)) {
					updatedOriginalValues[id] = emailData[findIndex].value;
				}

				emailData[findIndex].value = value;
				// setOtherEmail(value);
				setEmail(emailData);
				setFields(emailData);
				setChangesFlag("yes");
				setOriginalEmailValues(updatedOriginalValues);

				const existingChangeIndex = changesArray.findIndex(
					(change) => change.name === "Alternative Email" || change.name === "Primary Email" && change.id === id
				);

				if (existingChangeIndex !== -1) {
					const updatedChangesArray = [...changesArray];
					updatedChangesArray[existingChangeIndex] = {
						oldvalue: updatedOriginalValues[id],
						newvalue: value,
						name: indexId == 0 ? "Primary Email" : "Alternative Email",
						id,
						flag: !updatedOriginalValues[id] ? "Add" : "Edit",
					};
					setChangesArray(updatedChangesArray);
				} else {
					const change = {
						oldvalue: updatedOriginalValues[id],
						newvalue: value,
						name: indexId == 0 ? "Primary Email" : "Alternative Email",
						id,
						flag: !updatedOriginalValues[id] ? "Add" : "Edit",
					};
					setChangesArray([...changesArray, change]);
				}
			} else {
				setEmail([...email, { id, value }]);
				setFields([...email, { id, value }]);

				setChangesFlag("yes");
				const change = {
					oldvalue: "",
					newvalue: value,
					name: indexId == 0 ? "Primary Email" : "Alternative Email",
					id,
				};
				setChangesArray([...changesArray, change]);
			}
		}
	};

	const removeFields = (index, id) => {
		setChangesFlag("yes")

		let data = [...email];
		let removedEmail = data[index].value == null ? "" : data[index].value;

		data.splice(index, 1);
		setEmail(data.map((data, index) => ({ ...data, "id": `email${index}`, value: data.value })));

		let value = [...fields];
		value.splice(index, 1);
		setFields(value.map((data, index) => ({ ...data, "id": `email${index}`, value: data.value })));
		const indexToRemove = changesArray.findIndex(obj => (obj.id == id) && (obj.flag == "Add"));

		if (indexToRemove !== -1) {
			let remainingArrays = changesArray.filter(obj => obj.id !== id);
			const updatedObjects = remainingArrays.map(obj => {
				const numericPart = parseInt(obj.id?.match(/\d+$/)[0]);
				if (numericPart > index) {
					return { ...obj, id: obj.id.startsWith('email') ? `email${numericPart - 1}` : obj.id };
				}
				return obj;
			});
			setChangesArray(updatedObjects)
		}
		else {
			if (removedEmail.trim() !== "") {
				let remainingArrays = changesArray.filter(obj => obj.id !== id);
				const updatedObjects = remainingArrays.map(obj => {
					const numericPart = parseInt(obj.id?.match(/\d+$/)[0]);
					if (numericPart > index) {
						return { ...obj, id: obj.id.startsWith('email') ? `email${numericPart - 1}` : obj.id };
					}
					return obj;
				});
				setChangesArray(updatedObjects)
				setChangesArray((prevChangesArray) => [
					...prevChangesArray,
					{ oldvalue: removedEmail, newvalue: "Alternative Email " + `${removedEmail}` + " has been removed", name: "Alternative Email", flag: "Remove" },
				]);
			}

		}
	};


	const handlePhoneAdd = () => {
		const length = phoneFields.length
		// console.log("length", length);
		// let object0 = {
		//     "oldvalue": "",
		//     "newvalue": "+1",
		//     "name": "Alternative Phone # Country Code",
		//     "id": `phoneNo${length}`,
		//     "flag": "Add"
		// };
		let object1 = {
			"oldvalue": "",
			"newvalue": "",
			"name": "Alternative Phone #",
			"id": `phoneNo${length}`,
			"flag": "Add"
		};
		let object2 = {
			"oldvalue": "",
			"newvalue": "",
			"name": "Alternative Phone # Extension",
			"id": `phoneNo${length}`,
			"flag": "Add"
		};
		changesArray.push(object1, object2);
		const values = [...phoneFields, { "phone_no": "", "extentation": "", "country_code": "+1", flag: "add" }];
		setPhoneFields(values.map((data, index) => { return { "id": `phoneNo${index}`, "phone_no": data.phone_no, "extentation": data.extentation, "country_code": data.country_code } }));
		setPhoneNo(values.map((data, index) => { return { "id": `phoneNo${index}`, "phone_no": data.phone_no, flag: data.flag, "extentation": data.extentation, "country_code": data.country_code } }));
	}
	const [originalValues, setOriginalValues] = useState({})
	const [originalEmailValues, setOriginalEmailValues] = useState({})

	const handleOnChange = (data, phnId, index) => {
		const id = phnId;
		const phone_no = data;

		const updatedOriginalValues = { ...originalValues };

		if (!phoneNo?.length) {
			setPhoneNo([{ ...phoneNo, id, phone_no }]);
			setPhoneFields([{ id, phone_no }]);
			updatedOriginalValues[id] = phone_no;
			setOriginalValues({ [id]: "" });
		} else {
			const findIndex = phoneNo.findIndex((myData) => myData.id === id);
			if (findIndex >= 0) {
				let phoneNoData = phoneNo;
				if (!updatedOriginalValues.hasOwnProperty(id)) {
					updatedOriginalValues[id] = phoneNoData[findIndex].phone_no;
				}
				phoneNoData[findIndex].phone_no = phone_no;
				setPhoneNo(phoneNoData);
				setPhoneFields(phoneNoData);
				setChangesFlag("yes");
				setOriginalValues(updatedOriginalValues);
				const existingChangeIndex = changesArray.findIndex(
					(change) => (change.name === "Alternative Phone #" || change.name === "Primary Phone #") && change.id === id
				);
				if (existingChangeIndex !== -1) {
					const updatedChangesArray = [...changesArray];
					updatedChangesArray[existingChangeIndex] = {
						oldvalue: updatedOriginalValues[id],
						newvalue: phone_no,
						name: index == 0 ? "Primary Phone #" : "Alternative Phone #",
						id,
						flag: !updatedOriginalValues[id] ? "Add" : "Edit"
					};
					setChangesArray(updatedChangesArray);
				} else {
					const change = {
						oldvalue: updatedOriginalValues[id],
						newvalue: phone_no,
						name: index == 0 ? "Primary Phone #" : "Alternative Phone #",
						id,
						flag: !updatedOriginalValues[id] ? "Add" : "Edit"
					};
					setChangesArray([...changesArray, change]);
				}
			} else {
				setPhoneNo([...phoneNo, { id, phone_no }]);
				setPhoneFields([...phoneNo, { id, phone_no }]);

				setChangesFlag("yes");
				const change = {
					oldvalue: "",
					newvalue: phone_no,
					name: index == 0 ? "Primary Phone #" : "Alternative Phone #",
					id,
				};
				setChangesArray([...changesArray, change]);
			}
		}
	};

	const removePhoneFields = (index, id) => {
		let data = [...phoneNo];

		let removedPhone = data[index].phone_no == null ? "" : data[index].phone_no;
		let removedPhone1 = data[index].extentation == undefined || data[index].extentation == null ? "" : data[index].extentation;
		let removedPhone2 = data[index].country_code == undefined || data[index].country_code == null ? "" : data[index].country_code;

		data.splice(index, 1)
		setPhoneNo(data.map((data, index) => ({ ...data, "id": `phoneNo${index}`, phone_no: data.phone_no })));
		let value = [...phoneFields];
		value.splice(index, 1)
		setPhoneFields(value.map((data, index) => ({ ...data, "id": `phoneNo${index}`, phone_no: data.phone_no, })));

		const indexToRemove = changesArray.findIndex(obj => (obj.id == id) && (obj.flag == "Add"));

		if (indexToRemove !== -1) {
			let remainingArrays = changesArray.filter(obj => obj.id !== id);
			const updatedObjects = remainingArrays.map(obj => {
				const numericPart = parseInt(obj.id?.match(/\d+$/)[0]);
				if (numericPart > index) {
					return { ...obj, id: obj.id.startsWith('phoneNo') ? `phoneNo${numericPart - 1}` : obj.id };
				}
				return obj;
			});
			setChangesArray(updatedObjects)
		}
		else {
			let remainingArrays = changesArray.filter(obj => obj.id !== id);
			const updatedObjects = remainingArrays.map(obj => {
				const numericPart = parseInt(obj.id?.match(/\d+$/)[0]);
				if (numericPart > index) {
					return { ...obj, id: obj.id.startsWith('phoneNo') ? `phoneNo${numericPart - 1}` : obj.id };
				}
				return obj;
			});

			const newChanges = [];

			if (removedPhone.trim() !== "") {
				newChanges.push({ oldvalue: removedPhone, newvalue: "Alternative Phone # " + `${removedPhone}` + " has been removed", name: "Alternative Phone #", flag: "Remove" });
			}

			if (removedPhone1.trim() !== "") {
				newChanges.push({ oldvalue: removedPhone1, newvalue: "Alternative Phone # Extension " + `${removedPhone1}` + " has been removed", name: "Alternative Phone # Extension", flag: "Remove" });
			}

			if (removedPhone2.trim() !== "") {
				newChanges.push({ oldvalue: removedPhone2, newvalue: "Alternative Phone # Country Code " + `${removedPhone2}` + " has been removed", name: "Alternative Phone # Country Code", flag: "Remove" });
			}

			setChangesArray([...updatedObjects, ...newChanges]);


		}
	}
	function formatPhone(value) {
		let i = 0;
		for (i = 0; i < value.length; i++) {
			var x = 0;
			x = value[i].replace(/\D/g, "").match(/(\d{3})(\d{3})(\d{4})/);
			value[i] = "(" + x[1] + ")" + x[2] + "-" + x[3];
		}
		return setPrimaryPhone(value);
	}

	const addUserview = (props, data) => {
		// event.preventDefault();
		console.log("addUserview");

		let request = {
			seller_search_id: searchName,
			seller_request_id: requestId == null ? "" : requestId,
			// seller_dealer_id: data == undefined || data === null ? successData.seller_dealer_id :data.seller_dealer_id,
			seller_dealer_request_id: sellerReqId == null ? "" : sellerReqId,

			seller_dealer_id: dealerData == undefined || dealerData === null ? successData.seller_dealer_id : dealerData.seller_dealer_id,
			create_user: user == 0 ? 0 : create_user,
			user_list: user,
			counter_bid: counter_bid,
			post_car: post_car,
			remove_car: remove_car,
			seller_id: successData.seller_id,
			seller_token: successData.seller_token,
			standing_seller_status_id: standingSellerStatusId,


		};
		console.log("----Seller request check---->", request);
		// return
		API.post("selleraddbysearch/add", request)
			.then((response) => {
				console.log("")
				if (response.data.success) {
					const { data } = response;
					console.log("response", response)
					togglePopup()
					setPopupTitle("Create AddUser");
					setPopupMsg("AddUser Successfully Created");
					setPopupType("success");
					setPopupActionType("redirect");
					setPopupActionValue("ok");
					setPopupActionPath("/seller")

				} else {
					togglePopup()
					setPopupTitle("Error");
					setPopupMsg(response.data.error.err);
					setPopupActionType("close");
					setPopupActionValue("close");
				}
			},)
			.catch(function (error) {
				if (error.response) {
					setAddErrors(error.response.data.error)
					setErrorFlag(true)
				}
			});


	}

	const registrationhandleSubmit = (data) => {
		// event.preventDefault();

		setFirstNameError("")
		setLastNameError("")
		setPhoneNumberError("")
		setEmailError("")
		setSslError("")
		setStandError("");

		setAddressError("")
		setoptionError("")
		setStateAndCityError("")

		phoneNo.map((data, index) => {
			document.getElementById(`phoneErr${index}`).innerHTML = "";
		})
		email.map((data, index) => {
			document.getElementById(`emailErr${index}`).innerHTML = "";
		})


		if (!firstName) {
			setFirstNameError("First Name is required")
			return;
		}
		else if (firstName.length > 50) {
			setFirstNameError("First Name must not exceed 50 characters")
			return;
		}

		if (!lastName) {
			setLastNameError("Last Name is required")
			return;
		}
		else if (lastName.length > 50) {
			setLastNameError("Last Name must not exceed 50 characters ")
			return;
		}

		if (phoneNo[0].phone_no === "" || phoneNo[0].phone_no === undefined) {
			document.getElementById(`phoneErr${0}`).innerHTML = "Phone Number is required";
			return;
		}
		if (phoneNo[0].phone_no !== "" && phoneNo[0].phone_no.length < 10) {
			document.getElementById(`phoneErr${0}`).innerHTML = "Phone Number must have 10 digits";
			return;
		}
		const phoneFilter = phoneNo.filter((data, index) => data.phone_no?.length < 10)
		if (phoneFilter.filter((data, index) => data.phone_no !== "")?.length > 0) {
			phoneNo.map((data, index) => {
				// document.getElementById(`phoneErr${index}`).innerHTML = "";
				if (data.phone_no !== "" && data.phone_no.length < 10) {
					document.getElementById(`phoneErr${index}`).innerHTML = "Phone Number must have 10 digits";
					return;
				}
			})
			return;
		}
		if (phoneNo.length > 0) {
			const phoneFilter = phoneNo.filter((data, index) => !(data.country_code == "" || data.country_code == undefined))
			if (phoneFilter.filter((data, index) => data.phone_no == "")?.length > 0) {
				phoneNo.map((data, index) => {
					if (data.country_code !== "" && data.phone_no == "") {
						document.getElementById(`phoneErr${index}`).innerHTML = "Phone # is required";
						return;
					}
				})
				return;
			}
		}
		if (phoneNo.length > 0) {
			const phoneFilter = phoneNo.filter((data, index) => !(data.extentation == "" || data.extentation == undefined))
			if (phoneFilter.filter((data, index) => data.phone_no == "")?.length > 0) {
				phoneNo.map((data, index) => {
					if (data.extentation !== "" && data.phone_no == "") {
						document.getElementById(`phoneErr${index}`).innerHTML = "Phone # is required";
						return;
					}
				})
				return;
			}
		}
		// const phoneFilter = phoneNo.filter((data, index) => data.phone_no?.length < 10)
		// if (phoneFilter.filter((data, index) => data.phone_no !== "")?.length > 0) {
		// 	phoneNo.map((data, index) => {
		// 		// document.getElementById(`phoneErr${index}`).innerHTML = "";
		// 		if (data.phone_no !== "" && data.phone_no.length < 10) {
		// 			document.getElementById(`phoneErr${index}`).innerHTML = "Phone Number must have 10 digits";
		// 			return;
		// 		}
		// 	})
		// 	return;
		// }


		if (phoneNo.length > 0) {
			for (let i = 0; i < phoneNo.length - 1; i++) {
				if (phoneNo[i].phone_no !== "") {
					for (let n = i + 1; n < phoneNo.length; n++) {
						// console.log(phoneNo[i].value, "phoneNo")
						// console.log(phoneNo[n].value, n, "phoneNos")
						if (phoneNo[i].phone_no === phoneNo[n].phone_no) {
							// console.log("same phoneNo entered", phoneNo[i].id, phoneNo[n].id);
							// document.getElementById(`phoneErr${phoneNo[n].id.slice(7)}}`).innerHTML = "Phone Number's should not be same";
							document.getElementById(`phoneErr${phoneNo[n].id.substring(phoneNo[n].id.length - 1)}`).innerHTML = "Phone Number's should not be same";
							return;
						}
					}
				} else {
					console.log("phone is Empty")
				}
			}
		}

		if (email[0].value === "" || email[0].value === undefined) {
			document.getElementById(`emailErr${0}`).innerHTML = "Email is required";
			return;
		}
		if (email.filter((data, index) => data.value && !new RegExp(/^[ ]*([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})[ ]*$/i).test(data.value)).length > 0) {
			// console.log("email 1st if calling");
			email.map((data, index) => {
				document.getElementById(`emailErr${index}`).innerHTML = "";
				// document.getElementById(`phoneErr${index}`).innerHTML = "";
				if (data.value && !new RegExp(/^[ ]*([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})[ ]*$/i).test(data.value)) {
					// console.log("email 2nd if Calling");
					document.getElementById(`emailErr${index}`).innerHTML = "Must match the Email format";
					return;
				}
			})
			return;
		}
		if (buyEmailsList1.find((data) => data.email === email[0].value)) /* || buyEmailsList2.find((data) => data.email === email[0].value) */ {
			document.getElementById(`emailErr${0}`).innerHTML = "This Email already exists";
			return;
			// if (sslNo.length > 0) {
			// 	document.getElementById(`emailErr${0}`).innerHTML = "";
			// } else {
			// 	document.getElementById(`emailErr${0}`).innerHTML = "This Email already exists, please enter your SSN #";
			// 	return;
			// }
		}
		if (email.length > 0) {
			for (let i = 0; i < email.length - 1; i++) {
				if (email[i].value !== "") {
					for (let n = i + 1; n < email.length; n++) {
						// console.log(email[i].value, "email")
						// console.log(email[n].value, n, "emails")
						if (email[i].value === email[n].value) {
							// console.log("same email entered", email[i].id, email[n].id);
							document.getElementById(`emailErr${email[n].id.slice(5)}}`).innerHTML = "Email Id's should not be same";
							return;
						}
					}
				} else {
					console.log("email is Empty")
				}
			}
		}



		if (sslNo.length > 0 && sslNo.length < 11) {
			setSslError("SSN #  must have Nine Numbers");
			return;
		}

		if (!address) {
			setAddressError("Address is required")
			return;
		}

		else if (address.length > 150) {
			setAddressError("Address must not exceed 150 characters")
			return;
		}
		if (!idStatename) {
			setStateAndCityError("1")
			return
		}
		if (!idCityname) {
			setStateAndCityError("2")
			return
		}
		if (!idZipcodename) {
			setStateAndCityError("3")
			return
		}
		if (!option) {
			setoptionError("How many years in car business is required")
			return;
		}

		const phoneNoList = phoneNo?.filter((data) => data?.phone_no !== "")
		const phoneData = phoneNoList?.filter((data) => data?.phone_no !== undefined)
		const emailList = email?.filter((data) => data?.value !== "")
		const filteredChangesArray = changesArray.filter(change => !(change.newvalue === ''));
		const filteredChangesflag = filteredChangesArray.length > 0 ? "yes" : "no"

		let request = {
			// seller_dealer_id: data == undefined || data === null ? successData.seller_dealer_id :data.seller_dealer_id,
			seller_dealer_id: dealerData == undefined || dealerData === null ? successData.seller_dealer_id : dealerData.seller_dealer_id,
			seller_dealer_request_id: sellerReqId == null ? "" : sellerReqId,
			seller_request_id: requestId == null ? "" : requestId,
			first_name: firstName,
			last_name: lastName,
			// phonenolist: phoneData.map(data => data.value),
			phonenolist: phoneData.map(({ id, ...rest }) => rest),
			emaillist: emailList.map(data => data.value),
			address: address,
			active: "0",
			country_id: parseInt(1),
			state_id: stateCityFlag === "" ? idStatename : "",
			city_id: stateCityFlag === "" ? idCityname : "",
			zipcode_id: stateCityFlag === "" ? idZipcodename : "",
			state_name: stateCityFlag !== "" ? idStatename : "",
			city_name: stateCityFlag !== "" ? idCityname : "",
			zipcode: stateCityFlag !== "" ? idZipcodename : "",
			// state_id: stateName,
			// city_id: cityName,
			// zipcode_id: zipCodeId,
			no_years: option,
			local_flag: 0,
			// buy_now: buy_now === 1 ? 1 : 0,
			// cancel_bid: cancel_bid === 1 ? 1 : 0,
			// bid: bid === 1 ? 1 : 0,
			// proxy_bid: proxy_bid === 1 ? 1 : 0,
			// counter_bid: counter_bid === 1 ? 1 : 0,
			// lot_fee: lot_fee === 1 ? 1 : 0,
			// buy_now: buy_now,
			// cancel_bid: cancel_bid,
			// bid: bid,
			// proxy_bid: proxy_bid,
			// counter_bid: counter_bid,
			// lot_fee: lot_fee,
			historylist: filteredChangesArray,
			valuechanges: filteredChangesflag,
			create_user: user == 0 ? 0 : create_user,
			user_list: user,
			counter_bid: counter_bid,
			post_car: post_car,
			remove_car: remove_car,
			local_flag: 0,
			ssl_no: sslNo,
			image: doc === "" ? doc : doc.length > 0 ? doc : [doc],
			createdBy: successData.seller_id,
			updatedBy: successData.seller_id,
			seller_id: successData.seller_id,
			seller_token: successData.seller_token,
			standing_seller_status_id: parseInt(stand) ? parseInt(stand) : 1,
			extentation: extentation


		};
		console.log("----new Seller request---->", request);
		// return
		API.post("seller/add", request)
			.then((response) => {
				console.log("")
				if (response.data.success) {
					const { data } = response;
					console.log("response", response)
					togglePopup()
					setPopupTitle("Create AddUser");
					setPopupMsg("AddUser Successfully Created");
					setPopupType("success");
					setPopupActionType("redirect");
					setPopupActionValue("ok");
					setPopupActionPath("/seller")

				} else {
					togglePopup()
					setPopupTitle("Error");
					setPopupMsg(response.data.error.err);
					setPopupActionType("close");
					setPopupActionValue("close");
				}
			}, (error) => {
				// setOpenLoader(false);
				// console.log(error);
				togglePopup()
				setPopupTitle("Error");
				setPopupMsg("Something went wrong, Please try Again");
				setPopupType("error");
				setPopupActionType("close");
				setPopupActionValue("close");
			})
			.catch(function (error) {
				if (error.response) {
					setAddErrors(error.response.data.error)
					setErrorFlag(true)
				}
			});


	}

	// const getStateName = (stateData) => {
	// 	setStateName(stateData)
	// 	setCityName(null)
	// 	setZipcodeId(null)
	// }

	// const getCityName = (cityData) => {
	// 	setCityName(cityData)
	// 	setZipcodeId(null)
	// }

	// const getZipCodeId = (zipData) => {
	// 	setZipcodeId(zipData)
	// }



	const getError = (data, flag) => {
		console.log("reg flag", data, flag);
		setAddErrors(data)
		setErrorFlag(flag)
	}



	const PivilegeDate = (data, privilegeType) => {
		/* privilegeType === "buy_now" && setBuyNow( data === 0 ? 1 : 0 );
		privilegeType === "cancel_bid"  && setCancelBid( data === 0 ? 1 : 0 );
		privilegeType === "bid" && setBid( data === 0 ? 1 : 0 );
		privilegeType === "proxy_bid" && setProxy_bid( data === 0 ? 1 : 0 );
		privilegeType === "counter_bid" && setCounter_bid( data === 0 ? 1 : 0 );
		privilegeType === "lot_fee" && setLot_fee( data === 0 ? 1 : 0 ); */
		privilegeType === "create_user" && setCreate_user(data === 0 ? 1 : 0);
		privilegeType === "counter_bid" && setCounter_bid(data === 0 ? 1 : 0);
		privilegeType === "post_car" && setPost_car(data === 0 ? 1 : 0);
		privilegeType === "remove_car" && setRemove_car(data === 0 ? 1 : 0);

	}
	useEffect(() => {
		setIdStatename(idStatename)
		setIdCityname(idCityname)
		setidZipcodename(idZipcodename)
	}, []);
	const DataStatus = () => {
		let request = {
			seller_token: successData.seller_token,
			seller_id: successData.seller_id,
		}

		API.post("standinglist/condition", request).then((response) => {

			if (response.data.success === true) {
				setStatus(response.data.data)
				setStatusStanding(response.data.data[0].standing)
			}
			else {
				setAddErrors(response.data.error)
				setErrorFlag(true)
			}
		}).catch(function (error) {
			if (error.response) {
				setAddErrors(error.response.data.error)
				setErrorFlag(true)
			}
		});


	}

	// const handlestatus = () => {
	// 	console.log( handlestatus, "handlestatus",)
	// 	setSelectedStatus(status.filter((data) => searchList.color ==  data.color)[0]?.standing)
	// 	// console.log("handlestatus", handlestatus);
	// }



	console.log(changesArray, "changesArray");
	const handleFirstName = (e) => {

		setChangesFlag("yes")
		const newValue = e.target.value;
		const oldvalue = "";
		setFirstName(newValue);
		const existingChangeIndex = changesArray.findIndex(change => change.name === 'First Name');
		if (existingChangeIndex !== -1) {
			const updatedChangesArray = [...changesArray];
			updatedChangesArray[existingChangeIndex] = { oldvalue, newvalue: newValue, name: 'First Name' };
			setChangesArray(updatedChangesArray);
		} else {
			const change = { oldvalue, newvalue: newValue, name: 'First Name' };
			setChangesArray([...changesArray, change]);
		}
	}

	const handleLastName = (e) => {

		setChangesFlag("yes")
		const newValue = e.target.value;
		const oldvalue = "";
		setLastName(newValue);
		const existingChangeIndex = changesArray.findIndex(change => change.name === 'Last Name');
		if (existingChangeIndex !== -1) {
			const updatedChangesArray = [...changesArray];
			updatedChangesArray[existingChangeIndex] = { oldvalue, newvalue: newValue, name: 'Last Name' };
			setChangesArray(updatedChangesArray);
		} else {
			const change = { oldvalue, newvalue: newValue, name: 'Last Name' };
			setChangesArray([...changesArray, change]);
		}

	}

	const onhandleBuyerStatus = (e) => {

		// setBuyerStatus(e.target.value)
		setSelectedStandingID(status.filter((data) => data.standing_id == e.target.value)[0]?.color)
		setChangesFlag("yes")
		const newValue = e.target.value;
		const oldvalue = "";
		setStand(newValue);
		const existingChangeIndex = changesArray.findIndex(change => change.name === 'Seller Status');
		if (existingChangeIndex !== -1) {
			const updatedChangesArray = [...changesArray];
			updatedChangesArray[existingChangeIndex] = { oldvalue, newvalue: newValue, name: 'Seller Status' };
			setChangesArray(updatedChangesArray);
		} else {
			const change = { oldvalue, newvalue: newValue, name: 'Seller Status' };
			setChangesArray([...changesArray, change]);
		}
	}
	const handleExtn = (e) => {
		setChangesFlag("yes")
		const newValue = e.target.value;
		const oldvalue = "";
		setExtentation(newValue);
		const existingChangeIndex = changesArray.findIndex(change => change.name === 'Extentation');
		if (existingChangeIndex !== -1) {
			const updatedChangesArray = [...changesArray];
			updatedChangesArray[existingChangeIndex] = { oldvalue, newvalue: newValue, name: 'Extentation' };
			setChangesArray(updatedChangesArray);
		} else {
			const change = { oldvalue, newvalue: newValue, name: 'Extentation' };
			setChangesArray([...changesArray, change]);
		}

	}
	const handleSSNChange = (e) => {
		setChangesFlag("yes")
		const inputSSN = e.target.value.replace(/\D/g, "");
		const inputLength = inputSSN.length;

		let formattedSSN = "";

		if (inputLength > 0) {
			formattedSSN = inputSSN.slice(0, 3);
		}
		if (inputLength > 3) {
			formattedSSN += "-" + inputSSN.slice(3, 5);
		}
		if (inputLength > 5) {
			formattedSSN += "-" + inputSSN.slice(5, 9);
		}
		const oldvalue = "";
		const newValue = formattedSSN
		setSslno(formattedSSN);
		console.log("formattedSSN", formattedSSN);
		const existingChangeIndex = changesArray.findIndex(change => change.name === 'ssn');
		if (existingChangeIndex !== -1) {
			const updatedChangesArray = [...changesArray];
			updatedChangesArray[existingChangeIndex] = { oldvalue, newvalue: newValue, name: 'ssn' };
			setChangesArray(updatedChangesArray);
		} else {
			const change = { oldvalue, newvalue: newValue, name: 'ssn' };
			setChangesArray([...changesArray, change]);
		}

	};
	const handleAddress = (e) => {
		setChangesFlag("yes")
		const newValue = e.target.value;
		const oldvalue = "";
		setAddress(newValue);
		const existingChangeIndex = changesArray.findIndex(change => change.name === 'Address');
		if (existingChangeIndex !== -1) {
			const updatedChangesArray = [...changesArray];
			updatedChangesArray[existingChangeIndex] = { oldvalue, newvalue: newValue, name: 'Address' };
			setChangesArray(updatedChangesArray);
		} else {
			const change = { oldvalue, newvalue: newValue, name: 'Address' };
			setChangesArray([...changesArray, change]);
		}

	}

	const getStateName = (stateData, flag, type) => {
		setChangesFlag("yes")
		const oldValue = "";

		setIdStatename(stateData)
		setStateCityFlag(flag)
		if (flag === "") {
			setIdCityname(null)
			setidZipcodename(null)
		}
		setChangesArray((prevChangesArray) => {
			const existingChangeIndex = prevChangesArray.findIndex((change) => change.name === type);

			if (existingChangeIndex !== -1) {
				const updatedChangesArray = [...prevChangesArray];
				updatedChangesArray[existingChangeIndex] = { oldvalue: oldValue, newvalue: stateData, name: type };
				return updatedChangesArray;
			} else {
				const change = { oldvalue: oldValue, newvalue: stateData, name: type };
				return [...prevChangesArray, change];
			}
		});
	}

	const onhandleCode = (data, phnId, index) => {
		const id = phnId;
		// const data1 = data.replace(/\D/g, "");
		const country_code = data;
		const updatedOriginalValues = { ...originalValues2 };
		if (!phoneNo?.length) {
			setPhoneNo([{ ...phoneNo, id, country_code }]);
			setPhoneFields([{ id, country_code }]);

			updatedOriginalValues[id] = country_code;
			setOriginalValues2({ [id]: "" });

		} else {
			const findIndex = phoneNo.findIndex((myData) => myData.id === id);
			if (findIndex >= 0) {
				let phoneNoData = phoneNo;
				if (!updatedOriginalValues.hasOwnProperty(id)) {
					updatedOriginalValues[id] = phoneNoData[findIndex].country_code;
				}

				phoneNoData[findIndex].country_code = country_code;
				setPhoneNo(phoneNoData);
				setPhoneFields(phoneNoData);
				setChangesFlag("yes");
				setOriginalValues2(updatedOriginalValues);
				const existingChangeIndex = changesArray.findIndex(
					(change) => (change.name === "Alternative Phone # Country Code" || change.name === "Primary Phone # Country Code") && change.id === id
				);

				if (existingChangeIndex !== -1) {
					const updatedChangesArray = [...changesArray];
					updatedChangesArray[existingChangeIndex] = {
						oldvalue: updatedOriginalValues[id],
						newvalue: country_code,
						name: index == 0 ? "Primary Phone # Country Code" : "Alternative Phone # Country Code",
						id,
						flag: !updatedOriginalValues[id] ? "Add" : "Edit"

					};
					setChangesArray(updatedChangesArray);
				} else {
					const change = {
						oldvalue: updatedOriginalValues[id],
						newvalue: country_code,
						name: index == 0 ? "Primary Phone # Country Code" : "Alternative Phone # Country Code",
						id,
						flag: !updatedOriginalValues[id] ? "Add" : "Edit"

					};
					setChangesArray([...changesArray, change]);
				}
			} else {
				setPhoneNo([...phoneNo, { id, country_code }]);
				setPhoneFields([...phoneNo, { id, country_code }]);

				setChangesFlag("yes");
				const change = {
					oldvalue: "",
					newvalue: country_code,
					name: index == 0 ? "Primary Phone # Country Code" : "Alternative Phone # Country Code",
					id,
				};
				setChangesArray([...changesArray, change]);
			}
		}
	};
	const getCityName = (cityData, flag, type) => {
		setChangesFlag("yes")
		const oldValue = "";
		setIdCityname(cityData)
		if (flag === "") {
			setidZipcodename(null)
		}
		setChangesArray((prevChangesArray) => {
			const existingChangeIndex = prevChangesArray.findIndex((change) => change.name === type);

			if (existingChangeIndex !== -1) {
				const updatedChangesArray = [...prevChangesArray];
				updatedChangesArray[existingChangeIndex] = {
					...updatedChangesArray[existingChangeIndex],
					newvalue: cityData,
				};
				return updatedChangesArray;
			} else {
				const change = { oldvalue: oldValue, newvalue: cityData, name: type };
				return [...prevChangesArray, change];
			}
		});
	};


	const getZipCodeId = (zipData, flag, type) => {
		setChangesFlag("yes")
		const oldValue = "";
		setidZipcodename(zipData)
		setChangesArray((prevChangesArray) => {
			const existingChangeIndex = prevChangesArray.findIndex((change) => change.name === type);
			const updatedFlag = flag || 'dropdown';
			if (existingChangeIndex !== -1) {
				const updatedChangesArray = [...prevChangesArray];
				updatedChangesArray[existingChangeIndex] = { ...updatedChangesArray[existingChangeIndex], newvalue: zipData, flag: updatedFlag };
				return updatedChangesArray;
			} else {
				const change = { oldvalue: oldValue, newvalue: zipData, name: type, flag: updatedFlag };
				return [...prevChangesArray, change];
			}
		});
	};

	const handleExp = (e) => {
		setChangesFlag("yes")
		const newValue = e.target.value;
		const oldvalue = "";
		setOption(newValue);
		const existingChangeIndex = changesArray.findIndex(change => change.name === 'Experience in car business');
		if (existingChangeIndex !== -1) {
			const updatedChangesArray = [...changesArray];
			updatedChangesArray[existingChangeIndex] = { oldvalue, newvalue: newValue, name: 'Experience in car business' };
			setChangesArray(updatedChangesArray);
		} else {
			const change = { oldvalue, newvalue: newValue, name: 'Experience in car business' };
			setChangesArray([...changesArray, change]);
		}

	}

	const handlePostcar = (e) => {
		setChangesFlag("yes")

		const newValue = e.target.value;
		setPost_car(newValue);
		const formattedOldValue = "";
		const formattedNewValue = newValue == 0 ? 'no' : 'yes';

		const existingChangeIndex = changesArray.findIndex(change => change.name === 'PostCar');
		if (existingChangeIndex !== -1) {
			const updatedChangesArray = [...changesArray];
			updatedChangesArray[existingChangeIndex] = {
				oldvalue: formattedOldValue,
				newvalue: formattedNewValue, name: 'PostCar'
			};
			setChangesArray(updatedChangesArray);
		} else {
			const change = {
				oldvalue: formattedOldValue,
				newvalue: formattedNewValue, name: 'PostCar'
			};
			setChangesArray([...changesArray, change]);
		}
	}
	const handleRemoveCar = (e) => {
		setChangesFlag("yes")

		const newValue = e.target.value;
		setRemove_car(newValue);
		const formattedOldValue = "";
		const formattedNewValue = newValue == 0 ? 'no' : 'yes';

		const existingChangeIndex = changesArray.findIndex(change => change.name === 'RemoveCar');
		if (existingChangeIndex !== -1) {
			const updatedChangesArray = [...changesArray];
			updatedChangesArray[existingChangeIndex] = {
				oldvalue: formattedOldValue,
				newvalue: formattedNewValue, name: 'RemoveCar'
			};
			setChangesArray(updatedChangesArray);
		} else {
			const change = {
				oldvalue: formattedOldValue,
				newvalue: formattedNewValue, name: 'RemoveCar'
			};
			setChangesArray([...changesArray, change]);
		}
	}

	const handleCounterbid = (e) => {
		setChangesFlag("yes")

		const newValue = e.target.value;
		setCounter_bid(newValue);
		const formattedOldValue = "";
		const formattedNewValue = newValue == 0 ? 'no' : 'yes';

		const existingChangeIndex = changesArray.findIndex(change => change.name === 'Counterbid');
		if (existingChangeIndex !== -1) {
			const updatedChangesArray = [...changesArray];
			updatedChangesArray[existingChangeIndex] = {
				oldvalue: formattedOldValue,
				newvalue: formattedNewValue, name: 'Counterbid'
			};
			setChangesArray(updatedChangesArray);
		} else {
			const change = {
				oldvalue: formattedOldValue,
				newvalue: formattedNewValue, name: 'Counterbid'
			};
			setChangesArray([...changesArray, change]);
		}
	}
	const handlecreateUser = (e) => {
		setChangesFlag("yes")

		const newValue = e.target.value;
		setCreate_user(newValue);
		const formattedOldValue = "";
		const formattedNewValue = newValue == 0 ? 'no' : 'yes';

		const existingChangeIndex = changesArray.findIndex(change => change.name === 'CreateUser');
		if (existingChangeIndex !== -1) {
			const updatedChangesArray = [...changesArray];
			updatedChangesArray[existingChangeIndex] = {
				oldvalue: formattedOldValue,
				newvalue: formattedNewValue, name: 'CreateUser'
			};
			setChangesArray(updatedChangesArray);
		} else {
			const change = {
				oldvalue: formattedOldValue,
				newvalue: formattedNewValue, name: 'CreateUser'
			};
			setChangesArray([...changesArray, change]);
		}
	}

	const handleUser = (e) => {
		setChangesFlag("yes")

		const newValue = e.target.value;
		setUser(newValue);
		const formattedOldValue = "";
		const formattedNewValue = newValue == 0 ? 'no' : 'yes';

		const existingChangeIndex = changesArray.findIndex(change => change.name === 'User');
		if (existingChangeIndex !== -1) {
			const updatedChangesArray = [...changesArray];
			updatedChangesArray[existingChangeIndex] = {
				oldvalue: formattedOldValue,
				newvalue: formattedNewValue, name: 'User'
			};
			setChangesArray(updatedChangesArray);
		} else {
			const change = {
				oldvalue: formattedOldValue,
				newvalue: formattedNewValue, name: 'User'
			};
			setChangesArray([...changesArray, change]);
		}
	}
	const onhandleExtentation = (data, phnId, index) => {
		const id = phnId;
		const data1 = data.replace(/\D/g, "");
		const extentation = data1;
		const updatedOriginalValues = { ...originalValues1 };
		if (!phoneNo?.length) {
			setPhoneNo([{ ...phoneNo, id, extentation }]);
			setPhoneFields([{ id, extentation }]);

			updatedOriginalValues[id] = extentation;
			setOriginalValues1({ [id]: "" });

		} else {
			const findIndex = phoneNo.findIndex((myData) => myData.id === id);
			if (findIndex >= 0) {
				let phoneNoData = phoneNo;
				if (!updatedOriginalValues.hasOwnProperty(id)) {
					updatedOriginalValues[id] = phoneNoData[findIndex].extentation;
				}

				phoneNoData[findIndex].extentation = extentation;
				setPhoneNo(phoneNoData);
				setPhoneFields(phoneNoData);
				setChangesFlag("yes");
				setOriginalValues1(updatedOriginalValues);
				const existingChangeIndex = changesArray.findIndex(
					(change) => (change.name === "Alternative Phone # Extension" || change.name === "Primary Phone # Extension") && change.id === id
				);

				if (existingChangeIndex !== -1) {
					const updatedChangesArray = [...changesArray];
					updatedChangesArray[existingChangeIndex] = {
						oldvalue: updatedOriginalValues[id],
						newvalue: extentation,
						name: index == 0 ? "Primary Phone # Extension" : "Alternative Phone # Extension",
						id,
						flag: !updatedOriginalValues[id] ? "Add" : "Edit"

					};
					setChangesArray(updatedChangesArray);
				} else {
					const change = {
						oldvalue: updatedOriginalValues[id],
						newvalue: extentation,
						name: index == 0 ? "Primary Phone # Extension" : "Alternative Phone # Extension",
						id,
						flag: !updatedOriginalValues[id] ? "Add" : "Edit"

					};
					setChangesArray([...changesArray, change]);
				}
			} else {
				setPhoneNo([...phoneNo, { id, extentation }]);
				setPhoneFields([...phoneNo, { id, extentation }]);

				setChangesFlag("yes");
				const change = {
					oldvalue: "",
					newvalue: extentation,
					name: index == 0 ? "Primary Phone # Extension" : "Alternative Phone # Extension",
					id,
				};
				setChangesArray([...changesArray, change]);
			}
		}
	};
	useEffect(() => fetchCountry()
		, [])

	async function fetchCountry() {
		const country = API.get('country');
		country.then((response) => {

			if (response.data.success === true) {
				setCountry(response.data.data);
			}
			else {
				setAddErrors(response.data.error.name)
				setErrorFlag(true)
			}

		}).catch(function (error) {
			if (error.response) {
				setAddErrors(error.response.data.error)
				setErrorFlag(true)
			}
		});
	}
	return (
		<div>
			<main id="main" className="inner-page">
				<div id="adduserpageinner" className="adduserpageinner">
					{errorFlag === true ? <PageNotFound error={addErrors} /> :
						<div className="container-fluid inner-page-space" >
							<div class="common-heading">
								<div className="row">
									<div className="col-lg-4">
									</div>
									<div className="col-lg-4">
										<div class="title">
											<p class="inner-title">Add Seller</p>
										</div>
									</div>
									<div className="col-lg-4">
									</div>
								</div>
							</div>
							<div className="adduserpageblock">
								<div className="row content">
									<div className="col-lg-4 col-md-12 col-sm-12 accountleftblock">
										<ManageAccountLinks />
									</div>
									<div className="col-lg-8 col-md-12 col-sm-12 adduserpagerightblock">
										<div className="adduserpage-inner">
											<div className="col-lg-12">
												{dealerFlag == true ?
													// =======================add by search=============
													<form class="adduserpageform" onSubmit={handleSubmit(addUserview)}>
														<div className="row">
															<div class="common-heading">
																<div className="row">
																	<div className="col-lg-4">
																		<div class="back-btn">
																			<button className="backBtn" onClick={() => history.push("/seller")}><i class="icofont-arrow-left"></i> Back</button>
																		</div>
																	</div>
																	<div className="col-lg-4">
																		<div class="title">
																			<p class="inner-title">Seller Details</p>
																		</div>
																	</div>
																	<div className="col-lg-4">
																	</div>
																</div>
															</div>
															<div className="filtersblock col-lg-9" >
																<div className="input-group searchbox">
																	<input type="text" className="form-control border" placeholder="Seller #" onChange={OnSearch} value={searchName}
																		onKeyDown={handleInput}></input>
																	<span className="input-group-append" >
																		<button className="btn ms-n5" type="button" id="btntest" name="btntest" onClick={() => { getSearchDetails(); }}><i className='bx bx-search'></i></button>

																	</span>

																</div>
															</div>
															<>
																<div className="col-lg-12 form-group view-img">
																	<div className="user-upload-btn-wrapper">
																		{doc === "" ? (
																			<img alt="" src={adduser} />
																		) : (
																			<img
																				alt=""
																				src={
																					doc.base64
																						? `data:${doc.type};base64,${doc.base64}`
																						: doc
																				}
																			/>
																		)}

																		<span className="proCamera"></span>

																		{type === "0" && (
																			<div className="form-input-error">
																				Upload only Image Format
																			</div>
																		)}

																		<input
																			type="file"
																			accept="image/png,image/jpeg,image/jpg"
																			style={{ display: "none" }}
																			id="profileImage"
																			onChange={getFiles}
																		/>

																		<label htmlFor="profileImage" className="camera-overlay"></label>
																	</div>
																</div>

																<div className="row">
																	<div className="section-buyer-title">
																		<h2>Seller Information</h2>
																	</div>
																	<div className="col-lg-12 form-group">
																		<div className="tbox">
																			<input className={sellerId != "" ?
																				statusColor == "pink"
																					? "tableRowPink form-control textbox"
																					: statusColor == "Silver"
																						? "tableRowSilver form-control textbox"
																						: statusColor == "Orange"
																							? "tableRowOrange form-control textbox"
																							: statusColor == "Navy blue"
																								? "tableRowNavyBlue form-control textbox"
																								: statusColor == "firered"
																									? "tableRowFireRed form-control textbox"
																									: statusColor == "Purple"
																										? "tableRowPurple form-control textbox"
																										: statusColor == "Yellow"
																											? "tableRowYellow1 form-control textbox"
																											: statusColor == "green"
																												? "tableRowGreenColor form-control textbox"
																												: statusColor == "blue"
																													? "tableRowBlue form-control textbox"
																													: statusColor == "darkred"
																														? "tableRowRed1 form-control textbox"
																														: statusColor == "black"
																															? "tableRowBlack1 form-control textbox"
																															: "form-control textbox" : ""} type="text" placeholder="" value={searchList?.seller_id}
																				disabled />
																			<label htmlFor="first_name" className={sellerId != "" ? "input-has-value" : ""}>Seller #</label>
																		</div>
																	</div>
																	<div className="col-lg-12 form-group">
																		<div className="tbox">
																			<input className="form-control textbox  " type="text" placeholder="" value={searchList?.first_name}
																				disabled />
																			<label htmlFor="first_name" className={firstName != "" ? "input-has-value " : ""}>First Name</label>

																		</div>
																	</div>
																	<div className="col-lg-12 form-group">
																		<div className="tbox">
																			<input className="form-control textbox  " type="text" placeholder="" value={searchList?.last_name}
																				disabled />
																			<label htmlFor="last_name" className={lastName != "" ? "input-has-value " : ""}>Last Name</label>

																		</div>
																	</div>
																	<div className="col-lg-12 form-group">
																		<div className="tbox">
																			<input className={sellerId != "" ?
																				searchList?.color == "pink"
																					? "tableRowPink form-control textbox"
																					: searchList?.color == "Silver"
																						? "tableRowSilver form-control textbox"
																						: searchList?.color == "Orange"
																							? "tableRowOrange form-control textbox"
																							: searchList?.color == "Navy blue"
																								? "tableRowNavyBlue form-control textbox"
																								: searchList?.color == "firered"
																									? "tableRowFireRed form-control textbox"
																									: searchList?.color == "Purple"
																										? "tableRowPurple form-control textbox"
																										: searchList?.color == "Yellow"
																											? "tableRowYellow1 form-control textbox"
																											: searchList?.color == "green"
																												? "tableRowGreenColor form-control textbox"
																												: searchList?.color == "blue"
																													? "tableRowBlue form-control textbox"
																													: searchList?.color == "darkred"
																														? "tableRowRed1 form-control textbox"
																														: searchList?.color == "black"
																															? "tableRowBlack1 form-control textbox"
																															: "form-control textbox" : ""} type="text" placeholder="" value={selectedStatus}
																				disabled />
																			<label htmlFor="first_name" className={selectedStatus != "" ? "input-has-value " : ""}>Seller Status</label>

																		</div>
																	</div>
																	<div className="col-lg-4 form-group countrycode">
																		<div className="tbox">
																			<input
																				type="text"
																				class="form-control"
																				id="extentation1"
																				value={searchList?.country_code}
																				disabled
																			/>
																			<label for="drop" className={"input-has-value"}>Country Code</label>
																		</div>
																	</div>
																	<div className="col-lg-5 form-group ">

																		<div className="tbox primry-code">
																			<PhoneInputs
																				className="textbox"
																				country={'us'}
																				disableDropdown={true}
																				disableCountryCode={true}
																				onlyCountries={['us']}
																				value={searchList?.phone_no}
																				placeholder=""
																				disabled
																			></PhoneInputs>

																			<label for="phone_no" className={phoneNo != "" ? "input-has-value" : ""}>Primary Phone #</label>
																		</div>
																	</div>
																	<div className="col-lg-3 form-group">
																		<div className="tbox extn-code">
																			<input
																				type="text"
																				class="form-control"
																				id="extentation1"
																				value={searchList?.extentation}
																				disabled
																			/>
																			<label for="drop" className={"input-has-value"}>Extension</label>

																		</div>
																	</div>

																	<div className="col-lg-4 form-group countrycode">
																		<div className="tbox">
																			{searchList.phonenolist.length > 0 ? searchList.phonenolist.map((data, index) =>
																				<>
																					<div className="">
																						<input
																							type="text"
																							class="form-control"
																							id="extentation12"
																							value={data?.country_code}
																							disabled
																						/>
																						<label for="drop" className={"input-has-value"}>Country Code</label>
																					</div>
																				</>) : ""}
																		</div>
																	</div>
																	<div className="col-lg-5 form-group ">
																		<div className="tbox primry-code ">
																			{primaryPhone.length > 0 ? primaryPhone.map((data, index) =>
																				<>
																					<PhoneInputs
																						className="textbox"
																						country={'us'}
																						disableDropdown={true}
																						disableCountryCode={true}
																						onlyCountries={['us']}
																						value={data}
																						disabled
																						placeholder=""
																					></PhoneInputs>
																					<label htmlFor={`phoneNo${index}`} className={data != "" ? "input-has-value" : ""}>Alternate Phone #</label>

																				</>) : ""}

																		</div>
																	</div>
																	<div className="col-lg-3 form-group">

																		{searchList.phonenolist.length > 0 ? searchList.phonenolist.map((data, index) =>
																			<>
																				<div className="tbox extn-code">
																					<input
																						type="text"
																						class="form-control"
																						id="extentation1"
																						value={data.extentation}
																						disabled
																					/>
																					<label for="drop" className={"input-has-value"}>Extension</label>
																				</div>
																			</>) : ""}


																	</div>

																	<div className="col-lg-12 form-group">
																		<div className="tbox">
																			<input className="form-control textbox  " type="text" placeholder="" value={searchList?.email}
																				disabled />
																			<label htmlFor="email" className={email != "" ? "input-has-value " : ""}>Email</label>

																		</div>
																	</div>
																	<div className="col-lg-12 form-group">
																		<div className="tbox">
																			{emailId.length > 0 ? emailId.map((data, index) =>
																				<>
																					<input type="email" defaultValue={data.email} className="form-control textbox  " placeholder="" disabled />
																					<label htmlFor={`email${index}`} className={data.email != "" ? "input-has-value " : ""}>Alternative Email</label>
																				</>
																			) : ""}
																		</div>
																	</div>

																	<div className="col-lg-12 form-group">
																		<div className="tbox">
																			<input className="form-control textbox  " type="text" placeholder="" value={searchList?.address}
																				disabled />
																			<label htmlFor="address" className={address != "" ? "input-has-value " : ""}>Address</label>

																		</div>
																	</div>
																	<div className="col-lg-12 form-group">
																		<div className="tbox">
																			<input className="form-control textbox " type="text" placeholder="" value={searchList?.state_name}
																				disabled />
																			<label htmlFor="state" className={state != "" ? "input-has-value " : ""}>State</label>

																		</div>
																	</div>
																	<div className="col-lg-12 form-group">
																		<div className="tbox">
																			<input className="form-control textbox  " type="text" placeholder="" value={searchList?.city_name}
																				disabled />
																			<label htmlFor="city_name" className={city != "" ? "input-has-value " : ""}>City</label>

																		</div>
																	</div>
																	<div className="col-lg-12 form-group">
																		<div className="tbox">
																			<input className="form-control textbox  " type="text" placeholder="" value={searchList?.zipcode}
																				disabled />
																			<label htmlFor="zipcode" className={zipcode != "" ? "input-has-value " : ""}>Zipcode</label>

																		</div>
																	</div>
																	<div className="col-lg-12 form-group">
																		<div className="tbox">
																			<input className="form-control textbox" type="text" placeholder="" value={searchList?.no_years}
																				disabled />
																			<label htmlFor="no_years" className={option != "" ? "input-has-value " : ""}>How Many years</label>

																		</div>
																	</div>
																</div>

																<div>
																	<div className="section-title">
																		<h2 className="buyertitle">Seller Privileges</h2>
																	</div>
																	<div className="col-sm-12">
																		<div className="radio input-group privileges">
																			<input id="radio-privileges" name="radio" type="radio" value={1} checked={post_car == 1 && remove_car == 1 && counter_bid == 1 && user == 1 && create_user == 1 ? true : false} onChange={(e) => setUserPrivileges(e.target.value)} />
																			<label htmlFor="radio-privileges" className="radio-label">Select Seller Privileges</label>
																		</div>

																		<div className=" row adduserpageforminner">
																			<div className="col-sm-6 form-group input-group">
																				<input type="checkbox" id="post_car" /* disabled={deselectPrivilege} */ checked={post_car == 0 ? false : true} value={post_car == 0 ? 1 : 0} onChange={(e) => setPost_car(e.target.value)} />
																				<label htmlFor="post_car">Post Car</label>
																			</div>
																			<div className="col-sm-6 form-group input-group ">
																				<input type="checkbox" id="remove_car" /* disabled={deselectPrivilege} */ checked={remove_car == 0 ? false : true} value={remove_car == 0 ? 1 : 0} onChange={(e) => setRemove_car(e.target.value)} />
																				<label htmlFor="remove_car">Remove Car</label>
																			</div>
																			<div className="col-sm-6 form-group input-group ">
																				<input type="checkbox" id="counterbid" /* disabled={deselectPrivilege} */ checked={counter_bid == 0 ? false : true} value={counter_bid == 0 ? 1 : 0} onChange={(e) => setCounter_bid(e.target.value)} />
																				<label htmlFor="counterbid">Counter Bid</label>
																			</div>
																			<div className="col-sm-6 form-group input-group ">
																				<input type="checkbox" id="User"/*  disabled={deselectPrivilege} */ checked={user == 0 ? false : true} value={user == 0 ? 1 : 0} onChange={(e) => setUser(e.target.value)} />
																				<label htmlFor="User">User</label>
																			</div>
																			{user == 1 ?
																				<div className="col-sm-6 form-group input-group ">
																					<input type="checkbox" id="createUser" disabled={user == 0 ? true : false} checked={create_user == 0 ? false : true} value={create_user == 0 ? 1 : 0} onChange={(e) => setCreate_user(e.target.value)} />
																					<label htmlFor="createUser">Create User</label>
																				</div>
																				: ""}
																		</div>
																	</div>
																	<div className="col-sm-12">
																		<div className="radio input-group noprivileges">
																			<input id="radio-noprivileges" name="radio" type="radio" value={0} checked={post_car == 1 || remove_car == 1 || counter_bid == 1 || user == 1 || create_user == 1 ? false : true} onChange={(e) => setUserPrivileges(e.target.value)} />
																			<label htmlFor="radio-noprivileges" className="radio-label">No privileges (Only View)</label>
																		</div>
																	</div>
																</div>
																<div className="col-lg-12 loginBtn">
																	<button className="cta-btn">Submit</button>
																</div>
															</>
														</div>
													</form>
													:
													// ===========normal add===========
													<form class="adduserpageform" onSubmit={handleSubmit(registrationhandleSubmit)}>
														<div className="row">
															<div class="common-heading">
																<div className="row">
																	<div className="col-lg-4">
																		<div class="back-btn">
																			<button className="backBtn" onClick={() => history.push("/seller")}><i class="icofont-arrow-left"></i> Back</button>
																		</div>
																	</div>
																	<div className="col-lg-4">
																		<div class="title">
																			<p class="inner-title">Seller Details</p>
																		</div>
																	</div>
																	<div className="col-lg-4">
																	</div>
																</div>
															</div>
															<div className="filtersblock col-lg-9" >
																<div className="input-group searchbox">

																	<input type="text" className="form-control border" placeholder="Seller #" onChange={OnSearch} value={searchName}
																		onKeyDown={handleInput}></input>
																	<span className="input-group-append" >
																		<button className="btn ms-n5" type="button" id="btntest" name="btntest" onClick={() => { getSearchDetails(); }}><i className='bx bx-search'></i></button>
																	</span>

																</div>
															</div>
															{/* <div className="section-title">

															<h2>Seller Details</h2>
														</div> */}
															{dealerFlag == true ?
																<div className="col-sm-12 form-group view-img">
																	<div className="user-upload-btn-wrapper">
																		<img alt="" src={/* myProfileObjc.image ||  */adduser} ></img>


																		{/* <span className="proCamera"></span>
                            {type==="0"?<div className="form-input-error">Upload only Image Format </div>:""}      
                            <FileBase64 onDone={ getFiles }  type="hidden"/>				 */}
																	</div>
																</div> :
																<div className="col-sm-12 form-group view-img">
																	<div className="user-upload-btn-wrapper">
																		{doc === "" ? (
																			<img alt="" src={adduser} />
																		) : (
																			<img
																				alt=""
																				src={
																					doc.base64
																						? `data:${doc.type};base64,${doc.base64}`
																						: doc
																				}
																			/>
																		)}

																		<span className="proCamera"></span>

																		{type === "0" && (
																			<div className="form-input-error">
																				Upload only Image Format
																			</div>
																		)}

																		<input
																			type="file"
																			accept="image/png,image/jpeg,image/jpg"
																			style={{ display: "none" }}
																			id="profileImage"
																			onChange={getFiles}
																		/>

																		<label htmlFor="profileImage" className="camera-overlay"></label>
																	</div>
																</div>}

															<div className="col-sm-12 form-group">
																<div className="tbox">
																	<input className="textbox " type="text" placeholder="" id="first_name" name="firstName" setFirstName
																		onChange={handleFirstName} />
																	<label htmlFor="first_name" title="First Name" className={firstName != "" ? "input-has-value required" : "required"}>First Name</label>
																	<p className="form-input-error" >{firstNameError}</p>
																</div>
															</div>
															<div className="col-sm-12 form-group">
																<div className="tbox">
																	<input className="textbox " type="text" placeholder="" id="last_name" name="lastName"
																		onChange={handleLastName} />
																	<label htmlFor="last_name" className={lastName != "" ? "input-has-value required" : "required"}>Last Name</label>
																	<p className="form-input-error" >{lastNameError}</p>
																</div>
															</div>
															<div class="col-sm-12 form-group selectTbox">
																<div className="tbox">
																	<select id="drop" placeholder="" name="dropoption"
																		className={
																			selectedStandingID == "pink"
																				? "tableRowPink form-control custom-select browser-default textbox"
																				: selectedStandingID == "Silver"
																					? "tableRowSilver form-control custom-select browser-default textbox"
																					: selectedStandingID == "Orange"
																						? "tableRowOrange form-control custom-select browser-default textbox"
																						: selectedStandingID == "Navy blue"
																							? "tableRowNavyBlue form-control custom-select browser-default textbox"
																							: selectedStandingID == "firered"
																								? "tableRowFireRed form-control custom-select browser-default textbox"
																								: selectedStandingID == "Purple"
																									? "tableRowPurple form-control custom-select browser-default textbox"
																									: selectedStandingID == "Yellow"
																										? "tableRowYellow1 form-control custom-select browser-default textbox"
																										: selectedStandingID == "green"
																											? "tableRowGreenColor form-control custom-select browser-default textbox"
																											: selectedStandingID == "blue"
																												? "tableRowBlue form-control custom-select browser-default textbox"
																												: selectedStandingID == "darkred"
																													? "tableRowRed1 form-control custom-select browser-default textbox"
																													: selectedStandingID == "black"
																														? "tableRowBlack1 form-control custom-select browser-default textbox"
																														: statusStanding == "Good" ?
																															"tableRowGreenColor form-control custom-select browser-default textbox"
																															: "form-control custom-select browser-default textbox"}
																		aria-label="Default select example"
																		onChange={onhandleBuyerStatus}
																	>
																		{/* <option style={{ "display": "none" }}></option> */}


																		{status.length > 0 &&
																			<>
																				{status.map((status) =>
																					<option className={status.color == "pink"
																						? "tableRowPink "
																						: status.color == "Silver"
																							? "tableRowSilver "
																							: status.color == "Orange"
																								? "tableRowOrange "
																								: status.color == "Navy blue"
																									? "tableRowNavyBlue "
																									: status.color == "firered"
																										? "tableRowFireRed "
																										: status.color == "Purple"
																											? "tableRowPurple "
																											: status.color == "Yellow"
																												? "tableRowYellow1 "
																												: status.color == "green"
																													? "tableRowGreenColor "
																													: status.color == "blue"
																														? "tableRowBlue "
																														: status.color == "darkred"
																															? "tableRowRed1 "
																															: status.color == "black" ?
																																"tableRowBlack1"
																																: ""}
																						key={status.standing_id} value={status.standing_id} >{status.standing}</option>)}
																			</>
																		}


																	</select>
																	<label htmlFor="no_years" className={"input-has-value required"}>Seller Status</label>
																	<p className="form-input-error">{standError}</p>

																</div>
															</div>
															<div className="col-sm-4 form-group countrycode">
																{phoneFields.length > 0 ? phoneFields.map((data, index) =>
																	<div className="tbox">
																		<select className="form-control custom-select browser-default textbox" id="drop" placeholder=""
																			onChange={(e) => onhandleCode(e.target.value, `phoneNo${index}`, index)} value={data.country_code}
																		>
																			<option style={{ display: "none" }}>{data.country_code}</option>
																			{country.length > 0 &&
																				<>
																					{country.map((country) => <>
																						<option key={country.id} value={`+${country.country_code}`} >
																							{country?.country_name}({`+${country.country_code}`})
																						</option>
																					</>)}
																				</>}
																		</select>
																		<label for="drop" className={"input-has-value required"}>Country Code</label>

																	</div>
																) : ""}
															</div>
															<div className="col-sm-5 form-group ">
																{phoneFields.map((item, index) =>
																	<div className="tbox primry-code ">

																		<PhoneInputs
																			className="textbox"
																			country={'us'}
																			disableDropdown={true}
																			disableCountryCode={true}
																			onlyCountries={['us']}
																			value={item.phone_no}
																			onChange={(data) => handleOnChange(data, `phoneNo${index}`, index)}
																			placeholder=""
																		></PhoneInputs>
																		<label htmlFor={`phoneNo${index}`} className={"input-has-value required"}>{index === 0 ? "Primary Phone #" : "Alternative Phone #"}</label>

																		<p className="form-input-error" id={`phoneErr${index}`} ></p>

																	</div>

																)}
															</div>
															<div className="col-sm-3 form-group">
																{phoneFields.map((data, index) =>
																	<div className="tbox extn-code">
																		<input
																			type="text"
																			class="form-control"
																			id="extentation1"
																			value={data.extentation}
																			onChange={(e) => onhandleExtentation(e.target.value, `phoneNo${index}`, index)}
																		/>
																		<label for="drop" className={"input-has-value"}>Extension</label>
																		{index === 0 ?

																			<button class="btn btn-outline-secondary rounded-1 ms-2 " type="button" id="button-addon2" onClick={handlePhoneAdd}>+ </button>

																			:
																			<button class="btn btn-outline-secondary rounded-1 ms-2" type="button" id="button-addon2" onClick={() => removePhoneFields(index, `phoneNo${index}`)}>-</button>

																		}
																	</div>
																)}
															</div>

															<div className=" col-lg-11 form-group">
																{fields.map((data, index) =>
																	<div className="tbox">

																		<input className="textbox" type="text" key={index} placeholder="" id={`email${index}`} name={`email${index}`}
																			value={data.value} onChange={(e) => onhandleEmail(e, index)} />
																		<label htmlFor={`email${index}`} className={email != "" ? "input-has-value required" : "required"}>{index === 0 ? "Primary Email" : "Alternative Email"}</label>
																		{index === 0 ?
																			<button class="btn btn-outline-secondary-2 rounded-1 " type="button" id="button-addon2 phnadd" onClick={handleAdd}> + </button>
																			:
																			<button class="btn btn-outline-secondary-2 rounded-1 " type="button" id="button-lesson2 phnadd" onClick={() => removeFields(index, `email${index}`)}> - </button>
																		}
																		<p className="form-input-error " id={`emailErr${index}`} ></p>

																	</div>

																)}

															</div>

															<div className="col-sm-12 form-group">
																<div className="tbox">
																	<input className="textbox " type="text" placeholder="" id="new-ssl" maxLength="300" value={sslNo} name="slnumber"
																		onChange={handleSSNChange} />
																	<label htmlFor="new-ssl" className={sslNo != "" ? "input-has-value " : ""}>SSN #</label>
																	<p className="form-input-error" >{sslError}</p>
																</div>
															</div>

															<div className="col-sm-12 form-group">
																<div className="tbox">
																	<input className="textbox " type="text" placeholder="" id="address" maxLength="300" name="address"
																		onChange={handleAddress} />
																	<label htmlFor="address" className={address != "" ? "input-has-value required" : "required"}>Address</label>
																	<p className="form-input-error" >{addressError}</p>
																</div>
															</div>

															<StateAndCitySearch
																setStateValue={(stateData, flag) => getStateName(stateData, flag, 'state')}
																setCityValue={(cityData, flag) => getCityName(cityData, flag, 'city')}
																setZipcodeValue={(zipData, flag) => getZipCodeId(zipData, flag, 'zipcode')}
																setNewError={getError}
																stateCityValidation={stateAndCityError}
																setRequired="true"


															/>
															{/* <div className="col-sm-12 form-group">
														<p className="form-input-error1"> {stateAndCityError}</p>
													</div> */}

															<div className="col-sm-8 form-group selectTbox">
																<div className="tbox">
																	{/* {/ <lable for="drop" className={option !="" ? "input-has-value" : ""}>How many years in car business</lable> /} */}
																	<select id="drop" placeholder="" name="dropoption" className="form-control custom-select browser-default textbox"
																		onChange={handleExp}>
																		<option style={{ "display": "none" }}></option>
																		<option value="Less then 1">Less then 1</option>
																		<option value="1-3">1-3</option>
																		<option value="3-5">3-5</option>
																		<option value="5-10">5-10</option>
																		<option value="10-15">10-15</option>
																		<option value="15-20">15-20</option>
																		<option value="More then 20">More then 20</option>
																	</select>

																	<label htmlFor="no_years" className={"input-has-value required"}>How many years in car business</label>
																	<p className="form-input-error" >{optionError}</p>
																</div>
															</div>

														</div>
														<div className="section-title">
															<h2 className="buyertitle">Seller Privileges</h2>
														</div>
														<div className="col-sm-12">
															<div className="radio input-group privileges">
																<input id="radio-privileges" name="radio" type="radio" value={1} checked={post_car == 1 && remove_car == 1 && counter_bid == 1 && user == 1 && create_user == 1 ? true : false} onChange={(e) => setUserPrivilegesAdd(e.target.value)} />
																<label htmlFor="radio-privileges" className="radio-label">Select Seller Privileges</label>
															</div>

															<div className=" row adduserpageforminner">
																<div className="col-sm-6 form-group input-group">
																	<input type="checkbox" id="post_car" /* disabled={deselectPrivilege} */ checked={post_car == 0 ? false : true} value={post_car == 0 ? 1 : 0} onChange={handlePostcar} />
																	<label htmlFor="post_car">Post Car</label>
																</div>
																<div className="col-sm-6 form-group input-group ">
																	<input type="checkbox" id="remove_car" /* disabled={deselectPrivilege} */ checked={remove_car == 0 ? false : true} value={remove_car == 0 ? 1 : 0} onChange={handleRemoveCar} />
																	<label htmlFor="remove_car">Remove Car</label>
																</div>
																<div className="col-sm-6 form-group input-group ">
																	<input type="checkbox" id="counterbid" /* disabled={deselectPrivilege} */ checked={counter_bid == 0 ? false : true} value={counter_bid == 0 ? 1 : 0} onChange={handleCounterbid} />
																	<label htmlFor="counterbid">Counter Bid</label>
																</div>
																<div className="col-sm-6 form-group input-group ">
																	<input type="checkbox" id="User" /* disabled={deselectPrivilege} */ checked={user == 0 ? false : true} value={user == 0 ? 1 : 0} onChange={handleUser} />
																	<label htmlFor="User">User</label>
																</div>
																{user == 1 ?
																	<div className="col-sm-6 form-group input-group ">
																		<input type="checkbox" id="createUser" disabled={user == 0 ? true : false} checked={create_user == 0 ? false : true} value={create_user == 0 ? 1 : 0} onChange={handlecreateUser} />
																		<label htmlFor="createUser">Create User</label>
																	</div>
																	: ""}
																{/* <div className="col-sm-6 form-group input-group ">
															<input type="checkbox" id="proxybid" disabled={ deselectPrivilege }  checked = { proxy_bid == 0 ? false : true } value={proxy_bid == 0 ? 1 : 0 } onChange={(e) => setProxy_bid(e.target.value)} />
															<label htmlFor="proxybid">Proxy Bid</label>
														</div>
														
														<div className="col-sm-6 form-group input-group ">
															<input type="checkbox" id="lotfee" disabled={ deselectPrivilege }  checked = { lot_fee == 0 ? false : true } value={lot_fee == 0 ? 1 : 0 } onChange={(e) => setLot_fee(e.target.value)} />
															<label htmlFor="lotfee">Lot Fee</label>
														</div> */}
															</div>
														</div>
														<div className="col-sm-12">
															<div className="radio input-group noprivileges">
																<input id="radio-noprivileges" name="radio" type="radio" value={0} checked={post_car == 1 || remove_car == 1 || counter_bid == 1 || user == 1 || create_user == 1 ? false : true} onChange={(e) => setUserPrivileges(e.target.value)} />
																<label htmlFor="radio-noprivileges" className="radio-label">No privileges (Only View)</label>
															</div>
														</div>
														<div className="col-lg-12 loginBtn">
															<button className="cta-btn">Submit</button>
														</div>
													</form>
												}
											</div>

										</div>
									</div>
								</div>
							</div>
						</div>}
				</div>
				<section id="playstoreBlock" className="playstoreBlock">
					<div className="container">
						<div className="row content">
							<div className="col-lg-12">
								<img src={appstore} />
								<img src={googleplay} />
							</div>
						</div>
					</div>
				</section>
				{isOpen &&
					<CommonPopup
						handleClose={togglePopup}
						popupTitle={popupTitle}
						popupMsg={popupMsg}
						popupType={popupType}
						popupActionType={popupActionType}
						popupActionValue={popupActionValue}
						popupActionPath={popupActionPath}
					/>}
			</main>
		</div>
	);
};
export default AddUser;
